import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MemberDetails, MemberQuery } from '@fgb/core';

@Component({
  selector: 'fgb-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
})
export class AccountDetailsComponent implements OnInit {
  member$: Observable<MemberDetails | undefined>;
  isEditing = false;

  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.member$ = this.memberQuery.selectMemberDetails();
  }

  edit() {
    this.isEditing = true;
  }

  onDetailsSaved() {
    this.isEditing = false;
  }
}
